document.querySelectorAll(".video__placeholder.youtube").forEach((btn) => {
  btn.addEventListener('click', () => {
    let btn_id = btn.getAttribute('data-play-id');
    document.querySelector(`.video__container[data-video-id="${btn_id}"] iframe`).setAttribute("src", "https://www.youtube.com/embed/" + btn_id + "?autoplay=1");
    document.querySelector(`.video__container[data-video-id="${btn_id}"]`).classList.remove('hide');
    btn.classList.add('hide');
  })
})

document.querySelectorAll(".video__placeholder.native").forEach((btn) => {
  btn.addEventListener('click', () => {
    let btn_id = btn.getAttribute('data-play-id');
    document.querySelector(`.video__container[data-video-id="${btn_id}"] video`).play();
    document.querySelector(`.video__container[data-video-id="${btn_id}"]`).classList.remove('hide');
    btn.classList.add('hide');
  })
})